var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTagsOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8901 15.0001L9.0901 9.0001H5C4.72386 9.0001 4.5 8.77624 4.5 8.5001C4.5 8.22395 4.72386 8.0001 5 8.0001H9.2901L10.5097 1.90204C10.5639 1.63126 10.8273 1.45565 11.0981 1.50981C11.3688 1.56396 11.5444 1.82737 11.4903 2.09815L10.3099 8.0001H15.2901L16.5097 1.90204C16.5639 1.63126 16.8273 1.45565 17.0981 1.50981C17.3688 1.56396 17.5444 1.82737 17.4903 2.09815L16.3099 8.0001H20.5C20.7761 8.0001 21 8.22395 21 8.5001C21 8.77624 20.7761 9.0001 20.5 9.0001H16.1099L14.9099 15.0001H19C19.2761 15.0001 19.5 15.224 19.5 15.5001C19.5 15.7762 19.2761 16.0001 19 16.0001H14.7099L13.4903 22.0982C13.4361 22.3689 13.1727 22.5445 12.9019 22.4904C12.6312 22.4362 12.4556 22.1728 12.5097 21.902L13.6901 16.0001H8.7099L7.49029 22.0982C7.43613 22.3689 7.17272 22.5445 6.90194 22.4904C6.63116 22.4362 6.45555 22.1728 6.50971 21.902L7.6901 16.0001H4C3.72386 16.0001 3.5 15.7762 3.5 15.5001C3.5 15.224 3.72386 15.0001 4 15.0001H7.8901ZM8.9099 15.0001H13.8901L15.0901 9.0001H10.1099L8.9099 15.0001Z",
    fill: "white",
    fillOpacity: 0.54
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagsOff);
export default __webpack_public_path__ + "static/media/Tags_off.e657317940372cec73c71d9aa26357ff.svg";
export { ForwardRef as ReactComponent };